import {createFileRoute, Navigate} from '@tanstack/react-router';

export const Route = createFileRoute('/_app/basketball/')({
    component: RouteComponent,
})

function RouteComponent() {
    return <Navigate to="/basketball/leagues/" />;
}
